/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup, Card, CardHeader, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts} from '../actions/quote'
import Category from "./Category.js"
import {supplier_arry} from "../config"
import { registerUser, receiveToken, doInit } from '../actions/auth';
import { toast } from 'react-toastify';

import {
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
import Product from "./IndexSections/Product.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";






// fake data generator
const getItems = (count, offset = 0) =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k + offset}-${new Date().getTime()}`,
    content: `item ${k + offset}`
  }));

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};
const grid = 8;

const getItemStyle = (isDragging, draggableStyle, index) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,

  // change background colour if dragging
  background: isDragging ? "lightgreen" : (index%2==0?"white":"#EDECEF"),
  display:'flex',
  width:'100%',
  // styles we need to apply on draggables
  ...draggableStyle
});
const getHeaderStyle = ()=>({
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,
  background:'#091E3F',
  fontWeight:'normal',
  display:'flex',
  width:'100%',
  color:'white',
  borderTopLeftRadius: '20px',
  borderTopRightRadius: '20px'
})
const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: 0,
  width: '100%',
  borderBottom: '6px solid #091E3F',
  minHeight:'80px',
  // marginBottom:'20px'
});

function Index(props) {
  const [state, setState] = useState([getItems(10), getItems(5, 10)]);
  const [tableData, setTableData] = useState([]);
  const [company, setCompany] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  
  const main = useRef();
  const [modal, setModal] = useState(false);
  const [logoImage, setLogoImage] = useState(null);
  const logoRef = useRef(null);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    axios.get('/users/editaccount').then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success"){
        const data = res.data.data
        setCompany(data.company)
        setFirstname(data.firstname)
        setLastname(data.lastname)
        setPhone(data.number)
        setEmail(data.email)
        setPassword(data.password)
      }
    })    
  },[]);

  function onDragEnd(result) {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    const sInd = +source.droppableId;
    const dInd = +destination.droppableId;

    if (sInd === dInd) {
      const items = reorder(state[sInd], source.index, destination.index);
      const newState = [...state];
      newState[sInd] = items;
      setState(newState);
    } else {
      const result = move(state[sInd], state[dInd], source, destination);
      const newState = [...state];
      newState[sInd] = result[sInd];
      newState[dInd] = result[dInd];

      setState(newState.filter(group => group.length));
    }
  }

  const onChange=(event)=> {
    setState({ [event.target.name]: event.target.value });
  }

  
  const doEdit=(e)=>{
    e.preventDefault();
    var data ={ 
      company: company, 
      number: phone, 
      firstname: firstname, 
      lastname: lastname, 
      email: email, 
      password: password 
    };
    axios.post('/users/editaccount', data).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success"){
        toast.success("You saved your account");
      }
      else{        
        toast.error(res.data.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again ');
    })
  }

  const onChangeLogo=(e)=>{
    setLogoImage(URL.createObjectURL(e.target.files[0]))
  }
  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="md" className="m-auto catalogues">
          <div style={{marginTop:'65px', textAlign:'center'}}>
            <p>Click on the images below to view on-line Catalogues with thousands of products.</p>

          </div>
          <Row>
            {/* 1-1 */}
            <Col  md="4">
              <a href="https://online.fliphtml5.com/kjnoo/obyq/#p=1" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/2023_Dogalogue-Front-Cover-Web2-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 1-2 */}
            <Col  md="4">
              <a href="https://www.ascolour.com.au" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/AS-Colour19-3-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 1-3 */}
            <Col  md="4">
              <a href="https://www.bisleyworkwear.com.au" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/BisleyCat2021-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 2-1 */}
            <Col  md="4">
              <a href="https://macleodscotland.com/" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/flexfitCatalogue2021-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 2-2 */}
            <Col  md="4">
              <a href="https://www.jbswear.com.au" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/JB2021Catalogue-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 2-3 */}
            <Col  md="4">
              <a href="https://www.portwest.com.au/market/" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/Portwest-Australian-Catalogue-2021-3-1-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 3-1 */}
            <Col  md="4">
              <a href="https://rockroosterfootwear.com/" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/Rockrooster-Cover-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 3-2 */}
            <Col  md="4">
              <a href="https://badworkwear.com.au/#" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/BAD19-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 3-3 */}
            <Col  md="4">
              <a href="https://www.dncworkwear.com.au" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/DNC-1-400x482.png").default}
                />
              </a>
            </Col>
            {/* 4-1 */}
            <Col  md="4">
              <a href="https://www.bizcollection.com.au/" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/BizCollection2021Catalogue-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 4-2 */}
            <Col  md="4">
              <a href="https://www.syzmik.com/au/" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/Syzmik21Catalogue-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 4-3 */}
            <Col  md="4">
              <a href="https://gracecollection.com.au/" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/Grace-Collection-pricelist_2021-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 5-1 */}
            <Col  md="4">
              <a href="https://www.aussiepacific.com.au/" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/aussiep19-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 5-2 */}
            <Col  md="4">
              <a href="https://www.headwear.com.au/en_au" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/HW17_Cover-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 5-3 */}
            <Col  md="4">
              <a href="https://www.ramo.com.au/" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/Ramo_Cover-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 6-1 */}
            <Col  md="4">
              <a href="http://bocini.com.au/" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/BociniCover2017-400x482.jpg").default}
                />
              </a>
            </Col>
            {/* 6-2 */}
            <Col  md="4">
              <a href="https://www.expresswear.com.au/range" target="_blink">
                <img
                  alt="..."
                  src={require("assets/img/catalogues/Express-wear-400x482.png").default}
                />
              </a>
            </Col>
          </Row>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
